import { render, staticRenderFns } from "./BrokerLicense.vue?vue&type=template&id=6698f1ef&scoped=true&"
import script from "./BrokerLicense.vue?vue&type=script&lang=js&"
export * from "./BrokerLicense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6698f1ef",
  null
  
)

export default component.exports